import React, { useState } from "react";
import { Box, Text, Flex, Skeleton } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { FALLBACK_IMAGE, bucket_base_url } from "../../constants/constant";
import { imageCache } from "../../utils/constant";

export const BlogCard = ({ item }) => {
  const navigate = useNavigate();
  
  const imageSrc = item?.file?.[0]?.filePath 
    ? `${bucket_base_url}${item.file[0].filePath}` 
    : FALLBACK_IMAGE;

  const [isLoaded, setIsLoaded] = useState(() => imageCache.has(imageSrc));

  // Helper to safely format date
  const extractDate = (dateString) => {
    if (!dateString) return { month: "Jan", day: "01" };
    const dateObject = new Date(dateString);
    const month = dateObject.toLocaleDateString("en-US", { month: "short" });
    const day = dateObject.toLocaleDateString("en-US", { day: "2-digit" });
    return { month, day };
  };

  const { month, day } = extractDate(item?.createdAt);

  return (
    <Box
      bg="white"
      borderRadius="24px"
      overflow="hidden"
      textAlign="left"
      w="100%"
      maxW={{ base: "340px", md: "400px" }}
      mx="auto"
      cursor="pointer"
      transition="transform 0.2s ease, box-shadow 0.2s ease"
      _hover={{
        transform: "translateY(-4px)",
        boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.1)",
      }}
      onClick={() =>
        navigate("/blog-details", {
          state: {
            id: item,
          },
        })
      }
    >
      <Box position="relative">
        {!isLoaded && (
          <img
            src={FALLBACK_IMAGE}
            alt="Loading..."
            style={{
              width: "100%",
              height: "260px",
              objectFit: "cover",
              display: "block",
            }}
          />
        )}
        <img
          src={imageSrc}
          alt={item?.title}
          onLoad={() => {
            imageCache.set(imageSrc, true);
            setIsLoaded(true);
          }}
          onError={(e) => {
            imageCache.set(imageSrc, true);
            setIsLoaded(true);
            e.target.onerror = null;
            e.target.src = FALLBACK_IMAGE;
          }}
          style={{
            width: "100%",
            height: "260px",
            objectFit: "cover",
            display: isLoaded ? "block" : "none",
          }}
        />
        <Flex
          position="absolute"
          bottom="-25px"
          right="20px"
          bg="white"
          borderRadius="12px"
          boxShadow="0px 4px 15px rgba(0, 0, 0, 0.1)"
          w="70px"
          h="80px"
          direction="column"
          justifyContent="center"
          alignItems="center"
          zIndex={2}
        >
          <Text fontSize="14px" fontWeight="600" color="gray.600">
            {month}
          </Text>
          <Text fontSize="24px" fontWeight="800" color="gray.900" mt="-4px">
            {day}
          </Text>
        </Flex>
      </Box>
      <Box p={6} pt={8} bg="white">
        <Text
          fontWeight="700"
          fontSize="20px"
          color="gray.800"
          mb={3}
          noOfLines={1}
        >
          {item?.category || "Property News"}
        </Text>
        <Text
          fontWeight="600"
          fontSize="18px"
          color="gray.900"
          lineHeight="1.5"
          noOfLines={2}
        >
          {item?.title}
        </Text>
      </Box>
    </Box>
  );
};